export default "__VITE_ASSET__af774802__"